import type { Question } from '@mentimeter/legacy-series-types/question';
import type { Slide as VotingSlide } from '../../compatibility-overrides/voting-types';
import type { CompatibilitySlide } from '../../compatibility-types';
import type { CommonQuestionProperty } from './get-common-question-property';

export const getQuestionFreeTextProperty = (
  target: CompatibilitySlide | VotingSlide,
  prop: keyof Question,
) => {
  switch (prop as keyof Omit<Question, CommonQuestionProperty>) {
    case 'question':
      return target.title;
    case 'question_description':
      return target.title;
    default:
      return undefined;
  }
};
